<template>
  <sub-nav>
    <b-nav-item key="admin" 
      href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
      <router-link to="/admin">管理コマンド</router-link>
    </b-nav-item>
    <b-nav-item key="editchara" v-if="!$store.getters.test"
      href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
      <router-link to="/editchara">キャラクター管理</router-link>
    </b-nav-item>
    <!-- <b-nav-item key="miniicon" 
      href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
      <router-link to="/miniicon">アイコン</router-link>
    </b-nav-item>
    <b-nav-item key="setting" 
      href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
      <router-link to="/setting">設定</router-link>
    </b-nav-item> -->
  </sub-nav>
</template>

<script>
import SubNav from './SubNav'
export default {
  name: 'admin-nav',
  components: { SubNav }
}
</script>

<style lang="scss" scoped>
</style>
